(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smid-approved-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('smid-nav-dropdown')) {
    customElements.define('smid-nav-dropdown', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const details = this.querySelector('details');
        const summary = details.querySelector('summary');
        const desktop = () => matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1251px)').matches;
        this.addEventListener('pointerenter', () => {
          clearTimeout(this.closeTimer);
          if (desktop()) details.open = true;
        }, options);
        this.addEventListener('pointerleave', () => {
          if (desktop()) this.closeTimer = setTimeout(() => {
            if (!this.contains(document.activeElement) || !document.activeElement.matches(':focus-visible')) details.open = false;
          }, 150);
        }, options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) details.open = false;
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            event.stopPropagation();
            details.open = false;
            summary.focus();
          } else if (event.key === 'ArrowDown' && event.target === summary) {
            event.preventDefault();
            details.open = true;
            details.querySelector('a')?.focus();
          }
        }, options);
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) details.open = false;
        }, options);
      }
      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        this.abort?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smid-card-rail-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('smid-card-rail')) {
    customElements.define('smid-card-rail', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.track = this.querySelector('[data-rail-track]');
        this.controls = this.querySelector('[data-rail-controls]');
        if (!this.track || !this.controls) return;
        this.prev = this.querySelector('[data-rail-prev]');
        this.next = this.querySelector('[data-rail-next]');
        this.count = this.querySelector('[data-rail-count]');
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        const update = () => this.update();
        this.prev.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(update, 120);
        }, {...options, passive: true});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') this.scrollTo(event.key === 'Home' ? 0 : this.track.scrollWidth, true);
          else this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.track.addEventListener('focusin', event => {
          if (event.target === this.track) return;
          const item = Array.from(this.track.children).find(child => child.contains(event.target));
          if (!item) return;
          const bounds = this.track.getBoundingClientRect(), rect = item.getBoundingClientRect();
          if (rect.left < bounds.left || rect.right > bounds.right) this.scrollTo(this.track.scrollLeft + rect.left - bounds.left, true);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('[data-rail-item]');
          if (item) this.scrollTo(this.track.scrollLeft + item.getBoundingClientRect().left - this.track.getBoundingClientRect().left, true);
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        this.update();
      }
      scrollTo(left, instant = false) {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.targetLeft = Math.min(max, Math.max(0, left));
        this.track.scrollTo({left: this.targetLeft, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      move(direction) {
        const items = Array.from(this.track.children);
        if (items.length < 2) return;
        const step = items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const page = Math.max(1, Math.floor((this.track.clientWidth + gap + 1) / step));
        const base = this.targetLeft ?? this.track.scrollLeft;
        this.scrollTo(base + direction * step * page);
      }
      update() {
        const items = Array.from(this.track.children), bounds = this.track.getBoundingClientRect();
        const max = this.track.scrollWidth - this.track.clientWidth;
        const scrollLeft = this.track.scrollLeft;
        const visible = items.map((item,index) => ({rect:item.getBoundingClientRect(),index})).filter(({rect}) => rect.left < bounds.right - 20 && rect.right > bounds.left + 20);
        this.controls.hidden = max < 4;
        this.prev.disabled = scrollLeft < 4;
        this.next.disabled = scrollLeft >= max - 4;
        this.targetLeft = null;
        if (visible.length) {
          const first = visible[0].index + 1, last = visible[visible.length - 1].index + 1;
          const text = (first === last ? first : first + '–' + last) + ' / ' + items.length;
          if (this.count.textContent !== text) this.count.textContent = text;
        }
      }
      disconnectedCallback() {
        this.abort?.abort();this.abort = null;this.observer?.disconnect();clearTimeout(this.timer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smid-curtain-filter-group"] && !Shopify.designMode) return;
  try {
    class SmidCurtainFilters extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    onChange = (event) => {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-curtain-select]')) return;
      event.stopPropagation();
      const selected = new URL(event.target.value, location.origin);
      if (selected.origin !== location.origin || !selected.pathname.startsWith('/collections/')) return;
      const url = new URL(location.href);
      url.pathname = selected.pathname;
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      url.hash = 'ResultsList';
      this.setAttribute('aria-busy', 'true');
      location.assign(url.href);
    };
  }

  if (!customElements.get('smid-curtain-filters')) {
    customElements.define('smid-curtain-filters', SmidCurtainFilters);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smid-floer-contact-context"] && !Shopify.designMode) return;
  try {
    class SmidFloerContactContext extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const params = new URLSearchParams(location.search);
      const sunshade = [...params.keys()].some(name => name.startsWith('ss_'));
      if (!sunshade && params.get('product_offerte') !== '1' && params.get('floer_offerte') !== '1') return;
      const clean = (name, maximum) => (params.get(name) || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, maximum);
      const product = clean('product', 180);
      if (!product && !sunshade) return;
      const container = this.closest('.contact-form');
      const message = container?.querySelector('textarea[name="contact[body]"]');
      if (!message || (!sunshade && message.value.trim()) || container.querySelector('.contact-form__success, .contact-form__error')) return;
      const lines = [this.dataset.intro, '', this.dataset.productLabel + ': ' + product];
      const variant = clean('variant', 120);
      const sku = clean('sku', 80);
      if (!sunshade && variant && variant.toLowerCase() !== 'default title') lines.push(this.dataset.variantLabel + ': ' + variant);
      if (!sunshade && sku) lines.push(this.dataset.skuLabel + ': ' + sku);
      try {
        const url = new URL(params.get('product_url') || '', location.origin);
        if (url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/.test(url.pathname) && !url.username && !url.password) {
          url.search = '';
          url.hash = '';
          const variantId = clean('variant_id', 30);
          if (/^\d{1,30}$/.test(variantId)) url.searchParams.set('variant', variantId);
          lines.push(this.dataset.linkLabel + ': ' + url.href);
        }
      } catch {}
      const unit = clean('eenheid', 10);
      const readNumber = name => {
        const text = clean(name, 12);
        if (!/^\d+([.,]\d{1,2})?$/.test(text)) return null;
        const value = Number(text.replace(',', '.'));
        return value > 0 && value <= 100000 ? value : null;
      };
      const amount = readNumber('hoeveelheid');
      const format = value => new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 2 }).format(value);
      const decimalUnits = ['m2', 'meter', 'kg', 'liter'];
      const integerUnits = ['stuks', 'sets', 'paar', 'dozen', 'pakken', 'rollen', 'kleuren', 'zakken', 'bigbags', 'emmers', 'jerrycans', 'vaten', 'IBC', 'flacons', 'kokers'];
      if ([...decimalUnits, ...integerUnits].includes(unit) && amount !== null && (decimalUnits.includes(unit) || Number.isInteger(amount))) {
        const label = unit === 'm2' ? 'm\u00b2' : unit;
        lines.push('', 'Hoeveelheid: ' + format(amount) + ' ' + label);
        const extra = Number(clean('extra', 2));
        if (unit === 'm2' && [5, 10, 15].includes(extra)) {
          const total = Math.ceil(Math.round(amount * 100) * (100 + extra) / 100) / 100;
          lines.push('Extra materiaal: ' + extra + '%', 'Totaal aan te vragen: ' + format(total) + ' ' + label);
        }
        for (const [name, caption] of [['breedte', 'Breedte'], ['hoogte', 'Hoogte / uitval']]) {
          const value = readNumber(name);
          if (value !== null) lines.push(caption + ': ' + format(value) + ' cm');
        }
        const options = [['montage', 'Leggen / montage'], ['egaliseren', 'Egaliseren'], ['plinten', 'Plinten']].filter(([name]) => params.get(name) === 'ja').map(([, label]) => label);
        if (options.length) lines.push('Gewenste werkzaamheden: ' + options.join(', '));
      }
      lines.push('', this.dataset.projectPrompt);
      if (!sunshade) { message.value = lines.join('\n'); return; }
      message.removeAttribute('maxlength');
      this.sunshadePending = true;
      message.form?.addEventListener('submit', event => { if (this.sunshadePending) event.preventDefault(); });
      try {
        const { addSunshadeQuote } = await import(this.dataset.sunshadeModule);
        this.sunshadePending = !(await addSunshadeQuote({ context: this, container, message, params, base: lines.slice(3).join('\n') }));
      } catch {
        const status = document.createElement('p'); status.setAttribute('role', 'alert');
        status.textContent = JSON.parse(this.dataset.sunshadeLabels).error; message.before(status);
      }
    }
  }
  if (!customElements.get('smid-floer-contact-context')) customElements.define('smid-floer-contact-context', SmidFloerContactContext);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smid-floer-offer"] && !Shopify.designMode) return;
  try {
    class SmidFloerOffer extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.closest('.shopify-section, dialog')?.addEventListener('shopify:product:select', async (event) => {
        if (event.target instanceof Element && event.target.closest('product-card')) return;
        try {
          const { detail } = await event.promise;
          if (!detail?.html) return;
          const next = [...detail.html.querySelectorAll('smid-floer-offer')].find(element => element.dataset.blockId === this.dataset.blockId);
          if (!next) return;
          this.replaceChildren(...[...next.childNodes].map(node => node.cloneNode(true)));
          this.dataset.productId = next.dataset.productId;
        } catch (error) {
          if (error?.name !== 'AbortError') console.warn('Quotation variant update failed', error);
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('smid-floer-offer')) customElements.define('smid-floer-offer', SmidFloerOffer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smid-floor-explorer"] && !Shopify.designMode) return;
  try {
    (() => {
  const definitions = {
    pattern: ['rechte-planken','visgraat','walvisgraat','hongaarse-punt','tegels','mozaiek','design'],
    color: ['wit-creme','beige-taupe','bruin','grijs','zwart','blauw','groen','geel-goud','roze','paars','rood','oranje'],
    category: ['pvc','pvc-plak','pvc-klik','pvc-losleg','pvc-vrij','laminaat','parket','hybride-hout','tapijt','tapijttegels','linoleum','vinyl','vinyl-losleg','homogeen-vinyl','entreevloeren','naaldvilt','transportvloeren','kunstgras','keramische-tegels','terracotta-tegels','esd']
  };
  const prefixes = {pattern:'smid-patroon-',color:'smid-kleur-',category:'smid-vloer-categorie-'};
  const make = (tag, cls, text) => { const el=document.createElement(tag);if(cls)el.className=cls;if(text!==undefined)el.textContent=text;return el; };
  function orderPremiumFloors(items) {
    const primary = ['floer', 'moduleo', 'mflor'];
    const buckets = new Map([...primary, 'beautifloor', 'other', 'hamat'].map(vendor => [vendor, []]));
    for (const item of items) {
      const vendor = String(item.vendor).trim().toLowerCase();
      buckets.get(buckets.has(vendor) ? vendor : 'other').push(item);
    }
    const pinRank = item => item.priority < 0 ? Number.MAX_SAFE_INTEGER : item.priority;
    buckets.get('floer').sort((a, b) => pinRank(a) - pinRank(b) || a.rank - b.rank);
    const ordered = [];
    const secondary = buckets.get('beautifloor');
    const rounds = Math.max(...primary.map(vendor => buckets.get(vendor).length));
    for (let round = 0; round < rounds; round++) {
      for (const vendor of primary) {
        const item = buckets.get(vendor)[round];
        if (item) ordered.push(item);
      }
      if (round === 0 && secondary.length) ordered.push(secondary[0]);
    }
    ordered.push(...secondary.slice(rounds ? 1 : 0), ...buckets.get('other'), ...buckets.get('hamat'));
    return ordered;
  }
  class FloorExplorer extends HTMLElement {
    connectedCallback() {
      if(this.started)return;this.started=true;
      // Native collection URLs must keep their server-rendered results and pagination.
      const params=new URL(location.href).searchParams;
      const pageParams=params.getAll('page');
      const nativeRoute=this.dataset.firstPaint!=='true'||this.dataset.hasTags==='true'||Number(this.dataset.page)>1||params.has('sort_by')||[...params.keys()].some(key=>key.startsWith('filter.'))||pageParams.length>1||pageParams.some(page=>page!=='1');
      if(nativeRoute){
        const fallback=this.querySelector('.sfe-native-fallback');
        if(fallback)fallback.replaceWith(fallback.querySelector('.sfe-server'));
        this.dataset.firstPaint='false';return;
      }
      this.firstPaint=true;
      this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);
      this.pairs=JSON.parse(this.querySelector('[data-pairs]').textContent);
      this.seed=JSON.parse(this.querySelector('[data-seed]').textContent);
      this.priority=JSON.parse(this.querySelector('[data-priority]').textContent);
      this.firstProducts=this.seed.products;
      this.firstOrder=new Map([...this.querySelectorAll('.sfe-layout .sfe-card')].map((card,index)=>[card.dataset.product,index]));
      this.needsBootstrap=true;
      this.pages=new Map(this.seed.sort==='best-selling'&&!this.needsBootstrap?[[this.seed.page,this.seed.products]]:[]);
      this.selection={pattern:[],color:[],category:[],brand:[]};this.limit=12;this.complete=false;
      this.grid=this.querySelector('.sfe-layout .sfe-grid');this.count=this.querySelector('.sfe-count');this.status=this.querySelector('.sfe-status');this.facets=this.querySelector('.sfe-facets');
      this.readURL();this.bind();this.rebuild();
      // The recommended cards and filters already exist in HTML; hydrate them in place.
      this.load();
    }
    label(group,value){return group==='brand'?value:(this.labels[group+'_'+value]||value);}
    readURL(){
      const params=new URL(location.href).searchParams;
      for(const group of Object.keys(this.selection))this.selection[group]=params.getAll('sf_'+group);
      this.sort=params.get('sf_sort')||params.get('sort_by')||'best-selling';
      if(!['best-selling','price-ascending','price-descending','title-ascending','created-descending'].includes(this.sort))this.sort='best-selling';
      const tags=decodeURIComponent(location.pathname).split('/').slice(3).join('/').split('+');
      if(![...Object.values(this.selection)].flat().length){for(const tag of tags){for(const group of Object.keys(prefixes)){if(tag.startsWith(prefixes[group]))this.selection[group].push(tag.slice(prefixes[group].length));}}}
      this.querySelector('[data-sort]').value=this.sort;
    }
    bind(){
      const fallback=this.querySelector('.sfe-native-fallback');
      fallback?.addEventListener('toggle',()=>{if(this.complete&&!fallback.open)this.dataset.enhanced='true';});
      this.addEventListener('change',event=>{
        if(event.target.matches('[data-sort]'))this.sort=event.target.value;
        else if(event.target.matches('[data-group]')){
          const {group}=event.target.dataset;const set=new Set(this.selection[group]);event.target.checked?set.add(event.target.value):set.delete(event.target.value);this.selection[group]=[...set];
        }else return;
        this.limit=12;this.writeURL();this.render();
      });
      this.addEventListener('click',event=>{
        if(event.target.closest('[data-use-filters]')){this.dataset.enhanced='true';return;}
        const tab=event.target.closest('[data-tab]');
        if(tab){
          const value=tab.dataset.tab;
          if(value==='all'&&this.dataset.handle==='pvc-vloeren'){const target=new URL(location.href);target.pathname=this.dataset.path.replace(/\/pvc-vloeren$/,'/vloeren');for(const key of [...target.searchParams.keys()])if(key.startsWith('sf_')||key==='sort_by'||key==='page'||key.startsWith('filter.'))target.searchParams.delete(key);location.assign(target);return;}
          if(value==='brands'){
            const side=this.querySelector('.sfe-sidebar');side.dataset.open='true';this.querySelector('.sfe-toggle').setAttribute('aria-expanded','true');
            const brands=this.querySelector('[data-facet="brand"]');if(brands){brands.open=true;brands.scrollIntoView({behavior:'smooth',block:'center'});brands.querySelector('summary').focus();}return;
          }
          this.selection={pattern:[],color:[],category:[],brand:[]};
          if(value!=='all')this.selection[definitions.pattern.includes(value)?'pattern':'category']=[value];
          this.limit=12;this.writeURL();this.render();
        }
        const remove=event.target.closest('[data-remove]');if(remove){const [group,index]=remove.dataset.remove.split(':');this.selection[group].splice(Number(index),1);this.limit=12;this.writeURL();this.render();}
        if(event.target.closest('[data-clear]')){this.selection={pattern:[],color:[],category:[],brand:[]};this.limit=12;this.writeURL();this.render();}
        if(event.target.closest('.sfe-toggle')){const side=this.querySelector('.sfe-sidebar');const open=side.dataset.open!=='true';side.dataset.open=String(open);this.querySelector('.sfe-toggle').setAttribute('aria-expanded',String(open));}
        if(event.target.closest('.sfe-more')){this.limit+=24;this.render();}
        if(event.target.closest('.sfe-retry'))this.load();
      });
      this.onPop=()=>{this.readURL();this.limit=12;this.render();};window.addEventListener('popstate',this.onPop);
    }
    disconnectedCallback(){this.loadObserver?.disconnect();window.removeEventListener('popstate',this.onPop);}
    writeURL(){const url=new URL(location.href);url.pathname=this.dataset.path;url.searchParams.delete('page');url.searchParams.delete('sort_by');for(const key of [...url.searchParams.keys()])if(key.startsWith('filter.'))url.searchParams.delete(key);for(const group of Object.keys(this.selection)){url.searchParams.delete('sf_'+group);for(const value of this.selection[group])url.searchParams.append('sf_'+group,value);}url.searchParams.set('sf_sort',this.sort);history.pushState(null,'',url);}
    async fetchPage(page){
      const url=new URL(this.dataset.path,location.origin);url.searchParams.set('view','smid-floor-data');url.searchParams.set('sort_by','best-selling');url.searchParams.set('page',String(page));
      const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
      let response;for(let attempt=0;attempt<3;attempt++){response=await fetch(url,{credentials:'same-origin',signal:AbortSignal.timeout(15000)});if(response.ok)break;if(response.status!==429&&response.status<500)break;await new Promise(resolve=>setTimeout(resolve,500*(attempt+1)));}
      if(!response.ok)throw new Error('catalog');const data=JSON.parse(await response.text());if(data.page!==page||!Array.isArray(data.products))throw new Error('catalog');return data;
    }
    async load(){
      if(this.loading)return;this.loading=true;this.querySelectorAll('.sfe-retry').forEach(button=>button.hidden=true);this.failed=false;
      const recovery=this.querySelector('.sfe-recovery');if(recovery)recovery.textContent='';
      if(this.needsBootstrap){try{this.seed=await this.fetchPage(1);this.pages=new Map([[1,this.seed.products]]);this.needsBootstrap=false;}catch{this.loading=false;this.showLoadFailure();return;}}
      const pending=Array.from({length:this.seed.pages},(_,i)=>i+1).filter(n=>!this.pages.has(n));
      const worker=async()=>{while(pending.length&&!this.failed){const page=pending.shift();try{
        const data=await this.fetchPage(page);if(data.total!==this.seed.total){this.needsBootstrap=true;throw new Error('catalog changed');}
        this.pages.set(page,data.products);
        this.count.textContent=this.labels.loading+' '+Math.round(this.pages.size/this.seed.pages*100)+'%';
      }catch{this.failed=true;}}};
      await Promise.all([worker(),worker(),worker(),worker()]);this.loading=false;this.complete=this.pages.size===this.seed.pages;
      this.rebuild();
      if(this.complete)this.applyEnhancement();else this.showLoadFailure();
    }
    applyEnhancement(){if(this.querySelector('.sfe-native-fallback')?.open)this.querySelector('[data-use-filters]').hidden=false;else this.dataset.enhanced='true';}
    showLoadFailure(){this.status.textContent=this.labels.load_error;const recovery=this.querySelector('.sfe-recovery');if(recovery)recovery.textContent=this.labels.load_error;this.querySelectorAll('.sfe-retry').forEach(button=>button.hidden=false);}
    rebuild(){
      const products=[...this.pages.entries()].sort((a,b)=>a[0]-b[0]).flatMap(p=>p[1]);
      const byHandle=new Map(products.map((p,index)=>[p.handle,{...p,rank:index}]));
      if(!this.complete)for(const p of this.firstProducts)if(!byHandle.has(p.handle))byHandle.set(p.handle,{...p,rank:-1});
      const paired=new Map();
      for(const pair of this.pairs){if(byHandle.has(pair.plak)&&byHandle.has(pair.klik)){paired.set(pair.plak,pair);paired.set(pair.klik,pair);}}
      const seen=new Set();this.items=[];
      for(const p of byHandle.values()){
        const pair=paired.get(p.handle),key=pair?pair.plak:p.handle;if(seen.has(key))continue;seen.add(key);
        const options=pair?[byHandle.get(pair.plak),byHandle.get(pair.klik)]:[p];
        const tags=[...new Set(options.flatMap(o=>o.tags))];
        const item={key,options,title:pair?pair.title:p.title,vendor:p.vendor,rank:Math.min(...options.map(o=>o.rank)),created:Math.max(...options.map(o=>Number(o.created))),brand:[p.vendor]};
        for(const group of Object.keys(prefixes))item[group]=tags.filter(t=>t.startsWith(prefixes[group])).map(t=>t.slice(prefixes[group].length));
        if(tags.includes('smid-pvc-plak')&&!item.category.includes('pvc-plak'))item.category.push('pvc-plak');
        if(tags.includes('smid-pvc-klik')&&!item.category.includes('pvc-klik'))item.category.push('pvc-klik');
        if(item.category.some(c=>['pvc-plak','pvc-klik','pvc-losleg'].includes(c))&&!item.category.includes('pvc'))item.category.push('pvc');
        item.priority=this.priority.findIndex(priority=>options.some(o=>o.handle===priority.handle));
        this.items.push(item);
      }
      if(this.complete)this.buildFacets();this.render();
    }
    buildFacets(){
      const oldOpen=new Map([...this.facets.querySelectorAll('details')].map(d=>[d.dataset.facet,d.open]));this.facets.replaceChildren();
      for(const group of ['pattern','category','color','brand']){
        const values=group==='brand'?[...new Set(this.items.map(i=>i.vendor))].sort((a,b)=>a.localeCompare(b,'nl')):definitions[group].filter(value=>this.items.some(i=>i[group].includes(value)));
        if(!values.length)continue;const details=make('details','sfe-facet');details.dataset.facet=group;details.open=oldOpen.has(group)?oldOpen.get(group):true;
        details.append(make('summary','',this.labels[group]));const list=make('div','sfe-values');
        for(const value of values){const label=make('label');const input=make('input');input.type='checkbox';input.value=value;input.dataset.group=group;label.append(input,make('span','',this.label(group,value)),make('small'));list.append(label);}
        details.append(list);this.facets.append(details);
      }
    }
    matches(item,omit){return Object.entries(this.selection).every(([group,values])=>group===omit||!values.length||values.some(v=>item[group].includes(v)));}
    displayedOption(item){const choices=this.selection.category;return item.options.find(o=>choices.includes('pvc-klik')&&(o.tags.includes('smid-pvc-klik')||o.tags.includes('smid-vloer-categorie-pvc-klik')))||item.options.find(o=>choices.includes('pvc-plak')&&(o.tags.includes('smid-pvc-plak')||o.tags.includes('smid-vloer-categorie-pvc-plak')))||item.options[0];}
    sortingPrice(item){if(this.selection.category.some(c=>c==='pvc-klik'||c==='pvc-plak')){const selected=this.displayedOption(item);return selected.quote?null:selected.price;}const candidates=item.options.filter(o=>!o.quote);return candidates.length?Math.min(...candidates.map(o=>o.price)):null;}
    render(){
      let filtered=this.items.filter(item=>this.matches(item));
      if(this.sort==='best-selling'){
        filtered=orderPremiumFloors(filtered);
        if(!Object.values(this.selection).some(values=>values.length)){
          const firstRank=item=>this.firstOrder.has(item.key)?this.firstOrder.get(item.key):Number.MAX_SAFE_INTEGER;
          filtered.sort((a,b)=>firstRank(a)-firstRank(b));
        }
      }
      else filtered.sort((a,b)=>{
        if(this.sort.startsWith('price-')){const ap=this.sortingPrice(a),bp=this.sortingPrice(b);if(ap===null||bp===null)return ap===bp?a.rank-b.rank:(ap===null?1:-1);return this.sort==='price-ascending'?ap-bp:bp-ap;}
        if(this.sort==='title-ascending')return a.title.localeCompare(b.title,'nl');
        if(this.sort==='created-descending')return b.created-a.created;
        return a.rank-b.rank;
      });
      // Keep the first HTML cards, images, and galleries stable until the full selection is ready.
      if(this.complete){
        const visible=filtered.slice(0,this.limit);
        const signature=JSON.stringify(visible.map(item=>[this.displayedOption(item).handle,item.title,this.selection.category]));
        if(signature!==this.gridSignature){
          const current=[...this.grid.children];
          const initialMatch=!this.gridSignature&&!this.selection.category.length&&visible.length===current.length&&visible.every((item,index)=>this.displayedOption(item).handle===current[index].dataset.product);
          if(!initialMatch)this.grid.replaceChildren(...visible.map(item=>this.card(item)));
          this.gridSignature=signature;
        }
      }
      this.grid.setAttribute('aria-busy',String(!this.complete));
      this.count.textContent=this.complete?filtered.length.toLocaleString('nl-NL')+' '+this.labels.designs:this.labels.loading;
      this.querySelector('.sfe-more').hidden=!this.complete||filtered.length<=this.limit;
      this.status.textContent=this.complete?(filtered.length?Math.min(filtered.length,this.limit)+' '+this.labels.of+' '+filtered.length.toLocaleString('nl-NL')+' '+this.labels.designs:this.labels.empty):this.labels.loading_detail;
      for(const input of this.facets.querySelectorAll('input')){const group=input.dataset.group;const checked=this.selection[group].includes(input.value);input.checked=checked;const count=this.items.filter(i=>this.matches(i,group)&&i[group].includes(input.value)).length;input.disabled=this.complete&&!checked&&!count;input.parentElement.querySelector('small').textContent=this.complete?count.toLocaleString('nl-NL'):'';}
      const active=this.querySelector('.sfe-active');active.replaceChildren();for(const [group,values] of Object.entries(this.selection))values.forEach((value,index)=>{const button=make('button','',this.label(group,value)+' ×');button.type='button';button.dataset.remove=group+':'+index;active.append(button);});
      if(active.childElementCount){const clear=make('button','',this.labels.clear);clear.type='button';clear.dataset.clear='';active.append(clear);}
      for(const tab of this.querySelectorAll('[data-tab]')){const value=tab.dataset.tab;tab.setAttribute('aria-pressed',String(value==='all'?!Object.values(this.selection).flat().length:this.selection.pattern.includes(value)||this.selection.category.includes(value)));}
    }
    card(item){
      const product=this.displayedOption(item),card=make('article','sfe-card');card.dataset.product=product.handle;
      const link=make('a','sfe-details-link');link.href=product.url;
      const media=make(product.image&&product.imageCount>1?'smid-floor-gallery':'div','sfe-media');
      const imageLink=make('a','sfe-image-link');imageLink.href=product.url;imageLink.setAttribute('aria-label',item.title);media.append(imageLink);
      if(product.image){const image=make('img');const imageURL=new URL(product.image,location.origin);image.sizes='(max-width: 760px) 45vw, (max-width: 1050px) 25vw, 30vw';image.srcset=[360,540,720].map(width=>{const candidate=new URL(imageURL);candidate.searchParams.set('width',String(width));return candidate.href+' '+width+'w';}).join(', ');image.src=product.image;image.alt=item.title;image.width=720;image.height=480;image.loading='lazy';image.decoding='async';image.draggable=false;imageLink.append(image);}else imageLink.append(make('div','sfe-unavailable',this.labels.no_image));
      if(product.image&&product.imageCount>1){
        media.dataset.productUrl=product.url;media.dataset.errorLabel=this.labels.gallery_error;
        for(const step of [-1,1]){const button=make('button','sfe-gallery-arrow '+(step<0?'sfe-gallery-prev':'sfe-gallery-next'));button.type='button';button.dataset.galleryStep=String(step);button.setAttribute('aria-label',(step<0?this.labels.gallery_previous:this.labels.gallery_next)+' — '+item.title);const icon=make('span','',step<0?'‹':'›');icon.setAttribute('aria-hidden','true');button.append(icon);media.append(button);}
        const counter=make('span','sfe-gallery-count','1 / '+product.imageCount);counter.dataset.galleryCount='';counter.setAttribute('role','status');counter.setAttribute('aria-live','polite');counter.setAttribute('aria-atomic','true');media.append(counter);
        const status=make('span','sfe-gallery-status');status.dataset.galleryStatus='';status.setAttribute('role','status');media.append(status);
      }
      card.append(media);
      link.append(make('p','sfe-brand',item.vendor),make('h3','',item.title.replace(new RegExp('^'+item.vendor.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'\\s*[-–—]?\\s*','i'),'')));
      const price=make('p','sfe-price');const known=item.options.filter(o=>!o.quote);const different=known.length>1&&new Set(known.map(o=>o.price)).size>1;
      const chosen=this.selection.category.some(c=>c==='pvc-plak'||c==='pvc-klik');
      const priced=different&&!chosen?known.reduce((a,b)=>a.price<b.price?a:b):product;
      price.textContent=priced.quote?this.labels.on_request:(different&&!chosen?this.labels.from+' ':'')+priced.money+(priced.unit?' / '+priced.unit:'');link.append(price);
      if(!priced.quote)link.append(make('small','sfe-price-note',(priced.advice?this.labels.advice+' · ':'')+this.dataset.tax));
      if(item.options.length>1)link.append(make('span','sfe-choice',this.labels.choice));
      card.append(link);return card;
    }
  }
  if(!customElements.get('smid-floor-explorer'))customElements.define('smid-floor-explorer',FloorExplorer);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smid-floor-filter-group"] && !Shopify.designMode) return;
  try {
    class SmidFloorFilters extends HTMLElement {
    connectedCallback() { this.addEventListener('change', this.onChange); }
    disconnectedCallback() { this.removeEventListener('change', this.onChange); }

    onChange = (event) => {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-floor-filter-select]')) return;
      event.stopPropagation();
      const selected = new URL(event.target.value, location.origin);
      const base = this.dataset.collectionPath;
      if (!base || selected.origin !== location.origin || (selected.pathname !== base && !selected.pathname.startsWith(base + '/'))) return;
      const url = new URL(location.href);
      url.pathname = selected.pathname;
      for (const key of ['page', 'section_id', 'sections']) url.searchParams.delete(key);
      url.hash = 'ResultsList';
      this.setAttribute('aria-busy', 'true');
      location.assign(url.href);
    };
  }

  if (!customElements.get('smid-floor-filters')) customElements.define('smid-floor-filters', SmidFloorFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smid-opening-status"] && !Shopify.designMode) return;
  try {
    function smidIsOpenAt(date) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  }).formatToParts(date).map(part => [part.type, part.value]));
  const minutes = Number(parts.hour) * 60 + Number(parts.minute);
  const openingMinutes = parts.weekday === 'Sat' ? 510 : ['Wed', 'Thu', 'Fri'].includes(parts.weekday) ? 780 : null;
  return openingMinutes !== null && minutes >= openingMinutes && minutes < 1020;
}
if (!customElements.get('smid-opening-status')) {
  customElements.define('smid-opening-status', class extends HTMLElement {
    static get observedAttributes() { return ['data-force-closed']; }
    constructor() {
      super();
      this.refreshStatus = () => this.updateStatus();
    }
    connectedCallback() {
      this.updateStatus();
      clearInterval(this.timer);
      this.timer = setInterval(this.refreshStatus, 30000);
      document.addEventListener('visibilitychange', this.refreshStatus);
      window.addEventListener('pageshow', this.refreshStatus);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.refreshStatus);
      window.removeEventListener('pageshow', this.refreshStatus);
    }
    attributeChangedCallback() {
      if (this.isConnected) this.updateStatus();
    }
    updateStatus() {
      const open = this.dataset.forceClosed !== 'true' && smidIsOpenAt(new Date());
      this.dataset.open = String(open);
      const label = this.querySelector('[data-opening-label]');
      if (label) label.textContent = open ? 'Nu open' : 'Nu gesloten';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
